/* =====================================================
   COLUMN DEFINITIONS (AS PROVIDED)
   ===================================================== */

   type ColumnDef<T> = {
    header: string;
    key: keyof T;
  };
  
  /* ---------- Credit Instruments ---------- */
  
  export const CI_COLUMNS: ColumnDef<any>[] = [
    { header: "CRDTR", key: "creditorName" },
    { header: "BANK", key: "creditorName" },
  
    { header: "PRD", key: "productType" },
    { header: "PLN", key: "productType" },
    { header: "ACC_NO", key: "accountNumber" },
    { header: "LIMIT", key: "creditLimit" },
    { header: "ISSU_DT", key: "issueDate" },
    { header: "PROD_EXP_DT", key: "expiryDate" },
    { header: "STATUS", key: "status" },
    { header: "CLSD_DT", key: "closedDate" },
    { header: "TNR", key: "tenure" },
    { header: "FRQ", key: "frequency" },
    { header: "INSTL", key: "installmentAmount" },
    { header: "SAL", key: "salaryAssignment" },
    { header: "CUB", key: "pastDueBalance" },
    { header: "ODB", key: "outstandingBalance" },
    { header: "LAST_AMT_PD", key: "lastAmountPaid" },
    { header: "LAST_PAY_DT", key: "lastPaymentDate" },
    { header: "AS_OF_DT", key: "asOfDate" },
    { header: "NXT_DU_DT", key: "nextDueDate" },
    { header: "SUMMRY", key: "summary" },
    { header: "INSTL_New", key: "newInstallment" },
    { header: "FO", key: "financeOperation" },
  ];
  
  /* ---------- Defaults ---------- */
  
  export const DF_COLUMNS: ColumnDef<any>[] = [
    { header: "DF_PRD", key: "productType" },
    { header: "DF_CAPL", key: "capitalCode" },
    { header: "DF_ACC_NO", key: "accountNumber" },
    { header: "DF_CRDTR", key: "creditorName" },
    { header: "DF_LOAD_DT", key: "loadedDate" },
    { header: "DF_ORIG_AMT", key: "originalAmount" },
    { header: "DF_CUB", key: "unpaidBalance" },
    { header: "DF_STAT", key: "status" },
    { header: "DF_SETTLD_DATE", key: "settledDate" },
  ];
  
  /* ---------- Bounced Checks ---------- */
  
  export const BC_COLUMNS: ColumnDef<any>[] = [
    { header: "BC_PRD", key: "productType" },
    { header: "BC_CRDTR", key: "creditorName" },
    { header: "BC_CHECK_NO", key: "checkNumber" },
    { header: "BC_LOAD_DT", key: "checkDate" },
    { header: "BC_ORIG_AMT", key: "amount" },
    { header: "BC_CUB", key: "unpaidBalance" },
    { header: "BC_STAT", key: "status" },
  ];
  
  /* ---------- Judgements ---------- */
  
  export const EJ_COLUMNS: ColumnDef<any>[] = [
    { header: "EJ_ENFORCE_DATE", key: "enforceDate" },
    { header: "EJ_RES_NUMBER", key: "resolutionNumber" },
    { header: "EJ_EXEC_TYPE", key: "executionType" },
    { header: "EJ_CITY", key: "city" },
    { header: "EJ_COURT_CODE", key: "courtCode" },
    { header: "EJ_CASE_NUMBER", key: "caseNumber" },
    { header: "EJ_DATE_LOADED", key: "loadedDate" },
    { header: "EJ_ORIG_CLAIM_AMT", key: "originalClaimAmount" },
  ];
  
  /* =====================================================
     EXPORT FUNCTION
     ===================================================== */
  
  export const exportSimahReportToCSV = (
    apiResponse: {
      creditInstruments?: any[];
      defaults?: any[];
      bouncedChecks?: any[];
      judgements?: any[];
    },
    fileName = "simah_credit_report"
  ) => {
    const lines: string[] = [];
  
    const formatValue = (value: any) => {
      if (value === null || value === undefined || value === "") return "-";
  
      if (typeof value === "string" && value.includes("T")) {
        return value.split("T")[0];
      }
  
      const str = String(value);
      if (str.includes(",") || str.includes('"')) {
        return `"${str.replace(/"/g, '""')}"`;
      }
  
      return str;
    };
  
    const addSection = (
      title: string,
      rows: any[] | undefined,
      columns: ColumnDef<any>[]
    ) => {
      if (!rows || rows.length === 0) return;
  
      lines.push(title);
      lines.push(columns.map((c) => c.header).join(","));
  
      rows.forEach((row) => {
        lines.push(
          columns.map((c) => formatValue(row[c.key])).join(",")
        );
      });
  
      lines.push("");
    };
  
    addSection("CREDIT INSTRUMENTS", apiResponse.creditInstruments, CI_COLUMNS);
    addSection("DEFAULTS", apiResponse.defaults, DF_COLUMNS);
    addSection("BOUNCED CHECKS", apiResponse.bouncedChecks, BC_COLUMNS);
    addSection("JUDGEMENTS", apiResponse.judgements, EJ_COLUMNS);
  
    const csvContent = lines.join("\n");
    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });
  
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${fileName}.csv`;
  
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  